import { ReactComponent as KalamaLockupFormerly } from 'src/assets/images/kalama-lockup-formerly.svg'
import { isKalamaBrandingEnabled } from 'src/modules/brand/utils/kalama-branding'
import { FormattedText } from 'src/modules/core/components/formatted-text'
import { Typography } from 'src/modules/core/components/typography'
import type { SidebarBrandProps } from './sidebar-brand.interface'

const KALAMA_LOCKUP_LABEL = 'Kalama, formerly SMS Reminder'

export function SidebarBrand({ titleClassName, lockupClassName }: SidebarBrandProps) {
  if (isKalamaBrandingEnabled()) {
    return (
      <KalamaLockupFormerly className={lockupClassName} title={KALAMA_LOCKUP_LABEL} aria-label={KALAMA_LOCKUP_LABEL} />
    )
  }

  return (
    <Typography variant="h2" className={titleClassName}>
      <FormattedText id="common.companyName" />
    </Typography>
  )
}
